module.exports = __webpack_public_path__ + "march.f07d92e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/logos/march.png
// module id = onWx
// module chunks = 0